import { render, staticRenderFns } from "./LinksList.vue?vue&type=template&id=ffcfa894&scoped=true&"
import script from "./LinksList.vue?vue&type=script&lang=ts&"
export * from "./LinksList.vue?vue&type=script&lang=ts&"
import style0 from "./LinksList.vue?vue&type=style&index=0&id=ffcfa894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcfa894",
  null
  
)

export default component.exports